import { createSelector } from 'reselect';
import selectShop from '../../selectors/select-shop';

export const getShopErrors = createSelector(selectShop, ({ errors }) => errors || []);

// NOTE - this needs to be moved into ux-tread-cart-redux (partnercart-redux should be folded into cart-redux, but keep tread-partnercart separate)
export const getFilteredShopErrors = createSelector(
  getShopErrors,
  (state, props) => props.errorsToExclude || [],
  (errors, errorsToExclude) =>
    errors.filter(({ crcCode }) => crcCode && errorsToExclude.indexOf(crcCode) < 0),
);

export const getLatestShopError = createSelector(getFilteredShopErrors, errors => errors[0] || {});
